module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns-house_access_06-04b576a057443c7942df3f252075292c.jpg";